<template>
    <v-text-field
        v-on:input="[$emit('input', $event)]"
        :value="value"
        :prepend-inner-icon="icon"
        :rules="rules"
        :label="label"
        :placeholder="placeholder"
        outlined
        :disabled="disabled"
        @focus="$emit('focus')"
        @change="$emit('change')"
        @update:error="$emit('update:error', $event)"
        :prefix="prefix"
        :error-messages="errors"
        :validate-on-blur="validateOnBlur"
        :hide-details="hideDetails"
        :autofocus="autofocus"
        ref="input"
        :min="min"
        :max="max"
        :maxlength="phone ? '12' : zipCode ? '5' : maxlength"
        @keydown.enter="submit"
        :dense="dense"
        :loading="loading"
        :counter="counter"
        :type="
            password
                ? show
                    ? 'text'
                    : 'password'
                : email
                ? 'email'
                : number
                ? 'number'
                : phone
                ? 'tel'
                : 'text'
        "
        :append-icon="
            password ? (show ? 'visibility' : 'visibility_off') : appendIcon
        "
        :class="{ 'full-round': fullRound }"
        @click:append="$emit('append')"
    ></v-text-field>
</template>

<script>
import { preventDefault } from "@fullcalendar/common";
export default {
    name: "SoliText",
    props: {
        dense: { type: Boolean, default: true },
        validateOnBlur: { type: Boolean, default: false },
        hideDetails: { type: [Boolean, String], default: false },
        prevent: { type: Boolean, default: false },
        value: {},
        label: {},
        icon: {},
        rules: {},
        disabled: {
            type: Boolean,
            default: false,
        },
        password: {
            type: Boolean,
            default: false,
        },
        show: {},
        errors: {},
        placeholder: {},
        email: {},
        prefix: {},
        number: { type: Boolean, default: false },
        phone: { type: Boolean, default: false },
        zipCode: { type: Boolean, default: false },
        autofocus: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
            default: null,
        },
        max: {
            type: Number,
            default: null,
        },
        fullRound: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        appendIcon: {
            type: String,
            default: null,
        },
        counter: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: String,
            default: null,
        },
    },
    methods: {
        submit(event) {
            if (this.prevent) {
                event.preventDefault();
                this.$emit("blur");
            }
            this.$emit("keydown", event);
        },
        focus() {
            this.$refs.input.focus();
        },
    },
    mounted() {
        //if (this.autofocus) this.focus();
    },
};
</script>
